<template>
  <a-form-item
    v-if="data && options"
    :label="data.fieldname"
    class="from-cascader"
  >
    <a-cascader
      :value="defaultValue"
      :show-search="true"
      :options="options"
      change-on-select
      :placeholder="placeholder"
      :not-found-content="$t('message[1972]')"
      @change="onChange"
      @popupVisibleChange="popupVisibleChange"
    />

    <div
      v-if="data.showUrlInput"
      v-decorator="[`inputVal${index}`, {
        validateTrigger: [],
        rules: [{
          required: true,
          message: enterPlaceholder
        }],
        initialValue: inputVal
      }]"
      class="wrap"
    >
      <a-input
        v-model="inputVal"
        :placeholder="inputPlaceholder || enterPlaceholder"
        class="input"
        @input="onInputUrl"
      />
    </div>
  </a-form-item>
</template>

<script>
import _ from 'lodash'

export default {
  inject: ['myForm'],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    data: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: [String, Number],
      default: ''
    },
    getData: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      defaultValue: [],
      options: null,
      // showUrlInput: false,
      inputVal: '',
      inputPlaceholder: '',
      error: false
    }
  },
  computed: {
    placeholder () {
      if (!this.data) return

      const { fieldname = '', fieldconfig = {} } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      let string = placeholder || this.$t('message["855"]') + spaceStr + fieldname

      return string
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        // this.defaultValue = []

        this.getDefaultValue()
      },
      deep: true,
      immediate: true
    }
  },
  async created () {
    // this.init()
    this.setDefaultOptionsList()
  },
  methods: {
    async loadData () {
      const { fieldkey = '' } = this.data || {}
      const data = await this.getData({ fieldkey })

      return data
    },
    setOptions (options) {
      for (let item of options) {
        item.label = item.name || item.fieldname
        item.value = item.keyname === 'fieldkey' ? item.fieldkey : item.id
        item.key = item.pId + '-' + item.value

        if (item.child && item.child.length) {
          item.keyname = 'fieldkey'
          item.children = item.child
        } else if (item.options) {
          const arr = _.reduce(item.options, (res, item) => {
            item.keyname = 'id'
            res.push(item)
            return res
          }, [])
          item.children = arr
          item.keyname = 'id'
        }

        if (item.children && item.children.length) {
          for (let child of item.children) {
            child.pId = item.pId + '-' + item[item.keyname]
          }
          this.setOptions(item.children)
        }
      }
    },
    init () {
      // if (this.options.length && this.value[0]) {
      this.getDefaultValue()
      // }
    },

    /**
     * 将 value 的第一个值 fieldkey 转为ID
     */
    getDefaultValue () {
      // console.log(11, this.value)
      let value = []
      if (this.data.value && this.data.value.length) {
        value = this.data.value
      } else {
        value = this.value
      }
      if (this.data.fieldtype === 'from_info' && value && value.length) {
        this.defaultValue = value.map(item => item.id)
        // console.log('defaultValue', this.defaultValue)

        if (value[1] && value[1].fieldtype === 'text') {
          this.$set(this.data, 'showUrlInput', true)
          if (value[1].inputVal) {
            this.inputVal = value[1].inputVal
          } else {
            this.inputVal = ''
          }
        } else {
          this.$set(this.data, 'showUrlInput', false)
        }
      } else if (this.data.fieldtype === 'select_reception' && value && value.length) {
        this.defaultValue = value
      }
    },
    async setDefaultOptionsList () {
      const { options, child } = this.data

      this.options = options || child || []

      if (this.options && this.options.length) {
        for (let item of this.options) {
          item.pId = '0'
        }
        this.setOptions(this.options)
      }
    },
    onChange (value, selectedOptions) {
      // console.log('onChange', selectedOptions)
      this.defaultValue = value

      this.data.value = []
      if (selectedOptions && selectedOptions.length) {
        selectedOptions.forEach(item => {
          let obj = {}
          obj.fieldkey = item.fieldkey
          obj.id = item.id
          obj.fieldname = item.fieldname || item.name
          obj.keyname = item.keyname
          obj.key = item.key
          obj.fieldtype = item.fieldtype
          this.data.value.push(obj)
        })
      }
      if (this.data.fieldtype === 'select_reception') {
        this.data.value = value
      }
      this.$emit('change', this.data)
    },
    popupVisibleChange (val) {
      if (!val) {
        let { fieldtype, value = [] } = this.data || {}
        if (fieldtype === 'select_reception') return

        // 禁止选第二级
        if (this.defaultValue.length === 2) {
          if (value[1] && value[1].fieldtype === 'text') {
            this.$set(this.data, 'showUrlInput', true)
            this.inputPlaceholder = this.$t('message["751"]') + '' + value[1].fieldname
          } else {
            this.defaultValue = []
          }
        }
        // 选了第三级，清空输入框
        if (this.defaultValue.length === 3) {
          this.$set(this.data, 'showUrlInput', false)
          this.inputVal = ''
          this.inputPlaceholder = this.$t('message["751"]')
        }
      }
    },
    clearCascader () {
      this.defaultValue = []
    },
    onInputUrl (val) {
      if (this.data.value && this.data.value[1]) {
        this.data.value[1].inputVal = this.inputVal
      }
      this.myForm.setFieldsValue({
        [`inputVal${this.index}`]: this.inputVal
      })
      this.myForm.validateFields(['inputVal'], (err) => {
        if (!err) {}
      })
      this.$emit('change', this.data)
    }
  }
}
</script>

<style lang="scss" scoped>
/* .cascader-group::v-deep .cascader {
  .ant-form-item-label {
    display: none;
  }
  .ant-form-item-control-wrapper {
    padding-left: 0;
  }
} */
.from-cascader {
  .input {
    margin-top: 24px;
  }
  .error {
    padding: 4px 2px;
  }
}
</style>
